import React from "react";

function IconLot() {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 16.75V1.25C14 0.835787 13.6642 0.5 13.25 0.5H1.25C0.835788 0.5 0.5 0.835786 0.5 1.25V16.75C0.5 17.1642 0.835787 17.5 1.25 17.5H13.25C13.4489 17.5 13.6397 17.421 13.7803 17.2803C13.921 17.1397 14 16.9489 14 16.75ZM10.1998 9.57854L2.62122 2L12.5 2V7.29688L10.1998 9.57854ZM2 3.5001L9.1391 10.6392L3.77829 16H2L2 3.5001ZM12.4852 16H12.5V15.9852L12.4852 16ZM10.4999 16L8.19976 13.6999L5.89961 16H10.4999ZM9.26042 12.6392L12.5 9.39961V15.8788L9.26042 12.6392Z"
      />
    </svg>
  );
}

export default IconLot;
